import { Component, effect } from '@angular/core';
import { Button } from '@progress/kendo-angular-buttons';
import { BasicProfileEditComponent } from './basic-profile-edit/basic-profile-edit.component';
import { BasicProfileViewComponent } from './basic-profile-view/basic-profile-view.component';
import { ProfileService } from '../services/profile.service';

@Component({
  selector: 'app-basic-profile',
  standalone: true,
  imports: [Button, BasicProfileViewComponent, BasicProfileEditComponent],
  templateUrl: './basic-profile.component.html',
  styleUrl: './basic-profile.component.scss'
})
export class BasicProfileComponent {

  isEditing: boolean = false;

  constructor (public profileService: ProfileService) {

    effect(() => {
      this.isEditing = this.profileService.getBasicProfileEditingState();
    });
  }

  // Switch to edit mode
  toggleEditMode (): void {
    this.profileService.setBasicProfileEditingState(true);
  }
}
